import React from "react";

import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

import sub from "./assets/Subtract.svg";

interface EquipmentItem {
    title: string;
    price: string;
    img: string;
}

const Equipments: React.FC = () => {
    const defaultEquipmentImage = landingAsset("stadia.svg");
    const equip: EquipmentItem[] = [
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
        {
            title: "Professional Camera",
            price: "Contact for pricing",
            img: defaultEquipmentImage,
        },
    ];

    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">Available Equipment</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            Browse our wide selection of high-quality equipment available for
                            booking to enhance your match experience.
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col py-24 w-full px-4 md:px-14 bg-white">
                <div className="max-w-7xl mx-auto w-full">
                    <div className="space-y-4 mb-16">
                        <h3 className="text-green-700 font-black uppercase tracking-[0.2em] text-sm md:text-base">Gear Up</h3>
                        <h2 className="font-Manrope font-black text-3xl md:text-5xl text-gray-900 leading-tight">
                            High-Quality Equipment for Every Play
                        </h2>
                    </div>

                    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {equip.map((item, index) => (
                            <div
                                key={index}
                                className=" border border-gray-100 rounded-[32px] overflow-hidden group hover:shadow-2xl transition-all duration-500 bg-white"
                            >
                                <div
                                    style={{
                                        backgroundImage: `url(${item.img})`,
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                    }}
                                    className=" w-full aspect-square bg-gray-100 group-hover:scale-105 transition-transform duration-700"
                                ></div>
                                <div className=" w-full p-8 md:p-10 space-y-6">
                                    <p className=" font-Manrope font-black text-2xl md:text-3xl text-gray-900 group-hover:text-green-700 transition-colors">
                                        {item.title}
                                    </p>
                                    <div className=" flex items-center space-x-3 text-gray-500">
                                        <img src={sub} alt="" className="w-6 h-6" />
                                        <p className=" font-Manrope text-lg font-bold">
                                            {item.price}
                                        </p>
                                    </div>

                                    <button className=" py-5 w-full bg-green-700 hover:bg-green-800 rounded-2xl text-center mt-10 font-Manrope text-xl font-black text-white shadow-lg shadow-green-200 transition-all active:scale-95">
                                        Book Now
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Banner />
            <Footer />
        </>
    );
};

export default Equipments;
